import React, { PropsWithChildren } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

import { ResizeDivider } from './ResizeDivider';

interface Props extends PropsWithChildren {
  open: boolean;
  occupySpaceWhenClosed?: boolean;

  side: 'left' | 'right';

  sx?: SxProps<Theme>;

  width: number;
  setWidth: (width: number) => void;
}

export function ResizableSidebarDrawer({ open, occupySpaceWhenClosed, side, sx, width, setWidth, children }: Props) {
  const resizeHandle = (
    <ResizeDivider
      type="horizontal"
      value={width}
      onChange={(newValue) => {
        const delta = newValue - width;
        setWidth(width + (side === 'right' ? -delta : delta));
      }}
    />
  );

  return (
    <Box sx={open ? undefined : occupySpaceWhenClosed ? { visibility: 'hidden' } : { display: 'none' }}>
      <Box
        sx={{
          width,
          height: '100%',
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
        }}
      >
        {side === 'right' && resizeHandle}

        <Box
          sx={[
            {
              flexGrow: 1,
              width: '100%',
              overflowX: 'auto',
              overflowY: 'hidden',
              '&:hover': {
                overflowY: 'auto',
              },
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              scrollbarWidth: 'none',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}
        >
          {children}
        </Box>

        {side === 'left' && resizeHandle}
      </Box>
    </Box>
  );
}
